import * as React from 'react';

import { Spinner } from 'components/common';
import { useGetEventProcedure } from 'security-app/hooks/useEventProceduresAPI';

import Form from './Form';
import { INIT_EVENT_PROCEDURE } from './utils';

type Props = {
  eventProcedureId: string;
  remediationSteps?: string;
  onClose?: () => void;
  onSave?: (eventProcedureId: string) => void;
  onRemove?: (eventProcedureId: string) => void;
};

function PluggableEventProcedureForm({
  eventProcedureId,
  remediationSteps = undefined,
  onClose = undefined,
  onSave = undefined,
  onRemove = undefined,
}: Props) {
  const { eventProcedure, loadingEventProcedure } = useGetEventProcedure(eventProcedureId);

  if (loadingEventProcedure) return <Spinner text="Loading event procedure" />;

  if (remediationSteps) INIT_EVENT_PROCEDURE.description = remediationSteps;

  return (
    <Form
      eventProcedure={eventProcedure || INIT_EVENT_PROCEDURE}
      onSave={onSave}
      onDelete={onRemove}
      onCancel={onClose}
    />
  );
}

export default PluggableEventProcedureForm;
